import template from "./quote-activity.html";

const QuoteActivityComponent = {
  bindings: {
    quote: "<",
  },
  template: template,
  controller: class QuoteActivityController {
    /* @ngInject */
    constructor($rootScope, Quote) {
      this.$rootScope = $rootScope;
      this.Quote = Quote;
    }

    async $onInit() {
      this.loading = true;
      this.quoteLogs = [];
      this.quoteLogs = await this.Quote.getLogs(this.quote._id);

      this.loading = false;
      this.$rootScope.$applyAsync();
    }
  },
};

export default QuoteActivityComponent;
